import styled from 'styled-components';

// Main video player container
export const S3VideoPlayerWrapper = styled.div<{ deviceType?: string }>`
    position: relative;
    width: 100%;
    height: 100%;
    background: #000;
    overflow: hidden;
    cursor: ${(props) =>
        props.deviceType === 'DESKTOP' ? 'pointer' : 'default'};
`;

// Video element
export const VideoElement = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #000;
`;

// Media poster for HLS
export const MediaPoster = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
`;

// Top gradient overlay
export const TopGradient = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.6) 0%,
        transparent 100%
    );
    z-index: 2;
    pointer-events: none;
`;

// Main control container
export const MainControl = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Base control button styling
export const ControlButton = styled.button`
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.9);
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }
`;

// Specific control buttons
export const ReplayButton = styled(ControlButton)`
    width: 60px;
    height: 60px;
    font-size: 24px;
`;

export const PauseButton = styled(ControlButton)`
    width: 60px;
    height: 60px;
    font-size: 24px;
`;

export const PlayButton = styled(ControlButton)`
    width: 60px;
    height: 60px;
    font-size: 24px;
`;

// Close button
export const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 4;
    background: rgba(0, 0, 0, 0.7);
    border: none;
    border-radius: 50%;
    color: white;
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.3s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.9);
        transform: scale(1.1);
    }

    svg {
        fill: white;
        width: 14px;
        height: 14px;
    }

    img {
        filter: brightness(0) invert(1);
        width: 14px;
        height: 14px;
    }
`;

// Bottom controls container
export const BottomControls = styled.div<{ show?: boolean }>`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
    padding: 20px;
    z-index: 3;
    transition:
        opacity 0.3s ease,
        transform 0.3s ease;
    opacity: ${(props) => (props.show ? 1 : 0)};
    transform: translateY(${(props) => (props.show ? '0' : '100%')});
`;

// Controls top section
export const ControlsTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
    position: relative;
`;

// Time display container
export const TimeDisplay = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    position: absolute;
    left: 0;
`;

// Current time display
export const CurrentTime = styled.span`
    color: white;
`;

// Total time display
export const TotalTime = styled.span`
    color: rgba(255, 255, 255, 0.7);
`;

// Volume button
export const VolumeButton = styled.button`
    background: none;
    border: none;
    color: white;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Progress bar container
export const ProgressBar = styled.div`
    width: 100%;
    height: 6px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
    cursor: pointer;
    margin-bottom: 12px;
    position: relative;
    overflow: hidden;
`;

// Progress bar fill
export const ProgressFill = styled.div<{ progress: number }>`
    height: 100%;
    background: #ff6b6b;
    border-radius: 3px;
    width: ${(props) => props.progress}%;
    transition: width 0.1s ease;
`;

// Video title
export const VideoTitle = styled.div`
    color: white;
    font-size: 16px;
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
`;

// Loading overlay
export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 4;
`;

// Loading spinner
export const LoadingSpinner = styled.div`
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top: 3px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

// Error overlay
export const ErrorOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 4;
    color: white;
    text-align: center;
    padding: 20px;
`;
